import React from 'react';
import { Sprout, ShieldCheck, CloudSun, MapPin } from 'lucide-react';

/**
 * TrustHighlights — compact PDP trust list (competitive benchmark 2026-08).
 *
 * The field standard (frogdaddy / indoor ecosystems / tesoros) puts the
 * guarantees right next to the buy decision. Static copy, inline SVG
 * icons (lucide, currentColor stroke — no emoji), tokenized styling in
 * products.css (.listing-trust-block). Quiet, not loud: muted icons and
 * secondary text — these are facts, not a promo.
 *
 * Rendered inside the PDP right rail (desktop) / after the title block
 * (mobile stacked flow). Distinct from WeatherTrustBlock, the prose
 * "How we ship safely" card lower on the page.
 */
const ITEMS = [
  { Icon: Sprout, label: 'Captive-bred at our facility' },
  { Icon: ShieldCheck, label: 'Live Arrival Guarantee' },
  { Icon: CloudSun, label: 'Weather-checked before every ship date' },
  { Icon: MapPin, label: 'Hub delivery available' },
];

function TrustHighlights() {
  return (
    <ul className="listing-trust-block">
      {ITEMS.map(({ Icon, label }) => (
        <li key={label}>
          <Icon size={16} aria-hidden="true" focusable="false" />
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}

export default TrustHighlights;
